/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Theproduct1Inputs */

const id_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produk`)
};

const ms_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produk`)
};

const da_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produktet`)
};

const de_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`das Produkt`)
};

const en_us2_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the product`)
};

const es_es2_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`el producto`)
};

const es_mx2_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`el producto`)
};

const fil_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ang produkto`)
};

const fr_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`le produit`)
};

const it_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`il prodotto`)
};

const hu_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a terméket`)
};

const nl_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`het product`)
};

const no_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produktet`)
};

const pl_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produktu`)
};

const pt_br2_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the product`)
};

const pt_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o produto`)
};

const ro_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produsul`)
};

const fi_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tuotetta`)
};

const sv_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produkten`)
};

const vi_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sản phẩm`)
};

const tr_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ürün`)
};

const cs_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`produkt`)
};

const bg_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`продуктът`)
};

const ru_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`продукт`)
};

const uk_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`продукт`)
};

const ar_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنتج`)
};

const hi_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्पाद`)
};

const th_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผลิตภัณฑ์`)
};

const ja_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`製品`)
};

const zh_cn2_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the product`)
};

const zh_hant1_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the product`)
};

const ko_forms_review_theproduct1 = /** @type {(inputs: Forms_Review_Theproduct1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the product`)
};

/**
* | output |
* | --- |
* | "the product" |
*
* @param {Forms_Review_Theproduct1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_theproduct1 = /** @type {((inputs?: Forms_Review_Theproduct1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Theproduct1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_theproduct1(inputs)
	if (locale === "ms") return ms_forms_review_theproduct1(inputs)
	if (locale === "da") return da_forms_review_theproduct1(inputs)
	if (locale === "de") return de_forms_review_theproduct1(inputs)
	if (locale === "en-US") return en_us2_forms_review_theproduct1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_theproduct1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_theproduct1(inputs)
	if (locale === "fil") return fil_forms_review_theproduct1(inputs)
	if (locale === "fr") return fr_forms_review_theproduct1(inputs)
	if (locale === "it") return it_forms_review_theproduct1(inputs)
	if (locale === "hu") return hu_forms_review_theproduct1(inputs)
	if (locale === "nl") return nl_forms_review_theproduct1(inputs)
	if (locale === "no") return no_forms_review_theproduct1(inputs)
	if (locale === "pl") return pl_forms_review_theproduct1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_theproduct1(inputs)
	if (locale === "pt") return pt_forms_review_theproduct1(inputs)
	if (locale === "ro") return ro_forms_review_theproduct1(inputs)
	if (locale === "fi") return fi_forms_review_theproduct1(inputs)
	if (locale === "sv") return sv_forms_review_theproduct1(inputs)
	if (locale === "vi") return vi_forms_review_theproduct1(inputs)
	if (locale === "tr") return tr_forms_review_theproduct1(inputs)
	if (locale === "cs") return cs_forms_review_theproduct1(inputs)
	if (locale === "bg") return bg_forms_review_theproduct1(inputs)
	if (locale === "ru") return ru_forms_review_theproduct1(inputs)
	if (locale === "uk") return uk_forms_review_theproduct1(inputs)
	if (locale === "ar") return ar_forms_review_theproduct1(inputs)
	if (locale === "hi") return hi_forms_review_theproduct1(inputs)
	if (locale === "th") return th_forms_review_theproduct1(inputs)
	if (locale === "ja") return ja_forms_review_theproduct1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_theproduct1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_theproduct1(inputs)
	return ko_forms_review_theproduct1(inputs)
});
export { forms_review_theproduct1 as "forms.review.theProduct" }